import { registerApplication, start } from 'single-spa'
import { UserHelper, Logger } from '@Techedge/digitalportal-shared'
import packageJson from '../package.json'
import {
    constructApplications,
    constructRoutes,
    constructLayoutEngine,
} from 'single-spa-layout'

Logger._packageInfo(
    packageJson.name,
    packageJson.version,
    process.env.REACT_APP_ENV,
    process.env.NODE_ENV,
    'gold',
    'black'
)
if (process.env.REACT_APP_ENV === 'development') {
    localStorage.setItem('devtools', 'true')
}
const routes = constructRoutes(
    document.querySelector('#single-spa-layout') as HTMLTemplateElement
)

const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name)
    },
})

for (var i in applications) {
    if (applications[i].name.includes('sidebar')) {
        applications[i].customProps = {
            onSidebarMinify: (minified: boolean) => {
                if (minified) {
                    document
                        .querySelector('.main-content')
                        ?.classList.remove('sidebar-margins')
                    document
                        .querySelector('#smart-navbar')
                        ?.classList.remove('navbar-shrinked')
                    document
                        .querySelector('.sidebar-minify-btn .pi')
                        ?.classList.replace(
                            'pi-angle-double-left',
                            'pi-angle-double-right'
                        )
                } else {
                    document
                        .querySelector('.main-content')
                        ?.classList.add('sidebar-margins')
                    document
                        .querySelector('#smart-navbar')
                        ?.classList.add('navbar-shrinked')
                    document
                        .querySelector('.sidebar-minify-btn .pi')
                        ?.classList.replace(
                            'pi-angle-double-right',
                            'pi-angle-double-left'
                        )
                }
            },
        }
    }
}

const layoutEngine = constructLayoutEngine({ routes, applications })

applications.forEach(registerApplication)
layoutEngine.activate()

start({ urlRerouteOnly: true })

let loggedIn = false

const eventCallback = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const winParam = urlParams.get('win')

    if (!winParam || winParam !== 'iframe') {
        UserHelper._shared().setPortal('SMRT')
        const accessTokenParam = urlParams.get('jwt')
        const mode = urlParams.get('mode')
        const newApp = urlParams.get('new_app')

        if(mode == 'app') {
            sessionStorage.setItem('mode', mode)
            sessionStorage.setItem('newApp', newApp)
        }


        if (window.location.pathname === '/') {
            if (
                localStorage.getItem('ROOT_ACCESS_TOKEN') &&
                localStorage.getItem('ROOT_ACCESS_TOKEN') !== 'undefined'
            ) {
            } else {
                if (!accessTokenParam && mode !== 'app') {
                    window.location.href = process.env.DIGITAL_PORTAL_URL
                }
            }
        } else if (window.location.pathname === '/auth') {
            window.location.href = process.env.DIGITAL_PORTAL_URL
        } else {
            if (!accessTokenParam) {
                setTimeout(() => {
                    if (
                        (window.location.pathname !== '/logout' &&
                            !localStorage.getItem('ROOT_ACCESS_TOKEN')) ||
                        localStorage.getItem('ROOT_ACCESS_TOKEN') ===
                            'undefined'
                    ) {
                        window.location.href = process.env.DIGITAL_PORTAL_URL
                    }
                }, 500)
            }
        }
        if (
            !localStorage.getItem('ROOT_access_token') ||
            localStorage.getItem('ROOT_access_token') == 'undefined'
        ) {
            let _token = accessTokenParam
                ? accessTokenParam
                : localStorage.getItem('ROOT_ACCESS_TOKEN')
        }
        loggedIn = true
    }
}

window.addEventListener('single-spa:routing-event', eventCallback, true)
window.addEventListener('message', (msg: any) => {
    // console.log('inside smart-root event listener /w message: ', msg, msg?.data)
    if (msg.data === 'clear-local-storage') {
        localStorage.clear()
        sessionStorage.clear()
        if (process.env.REACT_APP_ENV === 'development') {
            localStorage.setItem('devtools', 'true')
        }
    }
})
